export interface WriteCookieProps {
    name: string;
    value: string;
    days?: number;
    path?: string;
}

export interface UpsertCookieProps {
    name: string;
    value: string;
    days?: number;
    path?: string;
}

export interface RemoveCookieProps {
    name: string;
    path?: string;
}

export class CookieManager {
    private cookies: { [key: string]: string } = {};

    constructor() {
        this._initialize();
    }

    private _initialize(): void {
        const cookies = document.cookie.split('; ');
        for (let cookie of cookies) {
            const [name, value] = cookie.split('=');
            if (name) {
                this.cookies[name] = decodeURIComponent(value || '');
            }
        }
    }

    private _writeCookie(props: WriteCookieProps): void {
        let cookieString = `${props.name}=${encodeURIComponent(props.value)}; path=${props.path ?? '/'}; SameSite=Lax`;

        if (props.days !== undefined) {
            const expires = new Date();
            expires.setTime(expires.getTime() + props.days * 24 * 60 * 60 * 1000);
            cookieString += `; expires=${expires.toUTCString()}`;
        }

        document.cookie = cookieString;
        this.cookies[props.name] = props.value;
    }

    upsert(props: UpsertCookieProps): void {
        if (!props.name) {
            console.warn('Cookie name cannot be empty.');
            return;
        }
        this._writeCookie(props);
    }

    get(name: string): string | null {
        return this.cookies[name] || null;
    }

    remove(props: RemoveCookieProps): void {
        this._writeCookie({ name: props.name, value: '', days: -1, path: props.path ?? '/' });
        delete this.cookies[props.name];
    }

    getAll(): { [key: string]: string } {
        return { ...this.cookies };
    }
}
